import React from 'react';
import { trackPromise } from 'react-promise-tracker';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export const FetchAPI = async (url, header) => {
    const response = await trackPromise(fetch(url, {
        method: 'GET',
        headers:  ( header != undefined ) ?  header : { clientToken: cookies.get('clientToken') },
    })).then(function (res) {
            return res;
    }).catch(function(error){
        const res = {status: (error.response === undefined) ?  400 :error.response.status, message: 'Oops..! Something went wrong.' }
        return res;
    });
    return response;
}